//@import dependencies
import React, { CSSProperties, useState } from 'react'
import { Link } from 'react-router-dom';
import Carousel from 'react-bootstrap/Carousel'
//@end

//@import components
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';
//@end

// @import hooks
// @end

// @INFO Import types
import {IBanner} from 'app_types/campus/banner/bannerTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../bannerModule.scss'
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent';
import { CiPlay1 } from 'react-icons/ci';
import { IoPauseOutline } from 'react-icons/io5';
import useWindowWidth from 'app_hooks/useWindowWidth';

const PLAY_INTERVAL = 5000
const PAUSE_INTERVAL = 1000 * 60 * 20
const MOVIL_BREAKPOINT = 768

// @ADD Component types
interface IBannerModuleLayoutProps {
  banners: Array<IBanner>
  activeIndex: number
  goToIndex: (index: number) => void
}

const navigationStyles: CSSProperties = {
  width: '48px',
  height: '48px',
  borderRadius: '50%',
  backgroundColor: 'var(--primary)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  opacity: 1
}

const BannerModuleLayout: React.FC<IBannerModuleLayoutProps> = (props) => {

  const [play, setPlay] = useState<boolean>(true)
  const { windowWidth } = useWindowWidth()
  const isMovil = windowWidth && windowWidth <= MOVIL_BREAKPOINT

  const handleClickBanner = (banner: IBanner) => {
    if (banner?.action) {
      window.open(banner.action, '_blank', 'noreferrer')
    }
  }

  return(
    <>
      {props.banners && Array.isArray(props.banners) && props.banners.length > 0 ? (
        <div className='banner_principal-component'>
          <div onClick={() => setPlay(!play)} className='banner-principal--play-control'>
            {play ? (
              <IoPauseOutline color='white' size='35px' />
            ) : (
              <CiPlay1 color='white' size='35px' />
            )}
          </div>
          <Carousel
            controls={true}
            indicators={true}
            interval={play ? PLAY_INTERVAL : PAUSE_INTERVAL}
            nextIcon={(
              <div style={navigationStyles}>
                <MdNavigateNext size='40px' color='#E5F7FF' />
              </div>
            )}
            prevIcon={(
              <div style={navigationStyles}>
                <MdNavigateBefore size='40px' color='#E5F7FF' />
              </div>
            )}
          >
            {props.banners.map((banner) => (
              <Carousel.Item
                style={{backgroundImage: `url(${banner.coverUrl})`}}
                key={banner.key}
                onClick={() => handleClickBanner(banner)}
                className={`banner-module--item ${banner?.action ? 'banner-module--item-url' : ''} ${banner?.positionOnScreen && !isMovil ? `banner-module--position-${banner.positionOnScreen}` : 'banner-module--position-left'}`}
              >
                <Carousel.Caption>
                  <div className="text-caption">
                    <div className='text-caption-header'>
                      <TooltipComponent text={banner.title}>
                        <h3>{banner.title}</h3>
                      </TooltipComponent>
                    </div>
                    <div className="text-caption-body">
                      <TooltipComponent text={banner.content}>
                        <p className="banner-content">{banner.content}</p>
                      </TooltipComponent>
                      {banner?.action || banner?.registerUrl ?
                        <div className="action-container">
                          {banner?.action ? (
                            <Link
                                to={{
                                    pathname: banner.action
                                }}
                                target='_blank'
                            >
                              <ButtonComponent
                                color='white'
                                border='1px solid white'
                                borderRadius='24px'
                                fontWeight={400}
                                textTransform='none'
                                textDecoration='none'
                                className='banner-module--button-action'
                              >
                                {banner?.actionText?.length ? banner.actionText : 'Más información'}
                              </ButtonComponent>
                            </Link>
                          ): null}
                          {banner?.registerUrl ? (
                            <Link
                                to={{
                                    pathname: banner.registerUrl
                                }}
                                target='_blank'
                                onClick={(e) => e.stopPropagation()}
                            >
                              <ButtonComponent
                                color='white'
                                border='1px solid white'
                                borderRadius='24px'
                                fontWeight={400}
                                textTransform='none'
                                textDecoration='none'
                                className='banner-module--button-action'
                              >
                                Registro
                              </ButtonComponent>
                            </Link>
                          ): null}
                        </div>
                      :null}
                    </div>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

      ): null}
    </>
  )
}

export default BannerModuleLayout
